import React, { forwardRef } from "react";
import styles from "./pill.module.scss";

const Pill = forwardRef(({ text, option = "rectangular", color, textColor, style }, ref) => {
  const pillStyle = {
    backgroundColor: color || "white",
    color: textColor || "black",
    ...style,
  };

  return (
    <span
      ref={ref} // Correctly forwarding ref here
      className={`${styles.pill} ${styles[option]}`}
      style={pillStyle}
    >
      {text}
    </span>
  );
});

// Ensure the display name is clear for debugging
Pill.displayName = "Pill";

export default Pill;
